/* globals L, mapObject, jQuery, urls */

// Declaring global variables
var map = {};
var curRoom = null;

var $ = jQuery.noConflict();

var selectedSeat = selectedSeat || null,
  hoveredSeat = hoveredSeat || null,
  seatIcon1 = L.divIcon({
    className: 'seat-icon-contain',
    iconSize: [25, 25]
  });

window.mapInit = function(objChartData, renderRoom, leafletConfig) {
  /*
   * http://leafletjs.com/reference-1.0.3.html
   * http://www.maptiler.com/
   */

  // set up leaflet map defaults
  leafletConfig.mapMinZoom = leafletConfig.mapMinZoom || 0;
  leafletConfig.mapMaxZoom = leafletConfig.mapMaxZoom || 2;
  leafletConfig.mapBounds = leafletConfig.mapBounds || [
    [0, 0],
    [-500, 313]
  ];
  leafletConfig.tileSize = leafletConfig.tileSize || 512;
  // coerce to boolean
  leafletConfig.enableZoomStyles = !!leafletConfig.enableZoomStyles;

  // TODO take these values from leafletConfig props
  var templateUrl = mapObject.templateUrl; // Site.php
  var mapTilePath = '/img/maptiles/';
  var mapTileDirectory = '';
  var mapVenueName = '';

  // If we don't have chart data for some reason (e.g. API failure), return false to stop this from erroring out
  if(!objChartData){
    return false;
  }

  if(renderRoom !== false){
    mapVenueName += objChartData.classrooms[renderRoom].mapTileDirectory;
    mapTileDirectory += mapVenueName + '/';
    mapTilePath += mapTileDirectory;
  }
  else if(objChartData && objChartData.startingRoom === 'overflow'){
    mapVenueName += objChartData.classrooms.overflow.mapTileDirectory;
    mapTileDirectory += mapVenueName + '/';
    renderRoom = 'overflow';
    mapTilePath += mapTileDirectory;
  }
  else{
    mapVenueName += objChartData.classrooms.main.mapTileDirectory;
    mapTileDirectory += mapVenueName + '/';
    renderRoom = 'main';
    mapTilePath += mapTileDirectory;
  }
  curRoom = renderRoom;

  var crs = L.CRS.Simple;
  // Enable custom scaling for new scientific program venue map
  if (leafletConfig.enableScaling) {
    crs.scale = function(zoom) {
      return Math.pow(2, zoom) / (Math.pow(2, 5));
    };
    // Use default scaling
  } else{
    crs.scale = function(zoom) {
      return Math.pow(2, zoom);
    };
  }

  /**********************************************
   * MAP
   */
  map = L.map('seating-chart-map', {
    maxZoom: leafletConfig.mapMaxZoom,
    minZoom: leafletConfig.mapMinZoom,
    crs: crs
  }).setView([0, 0], leafletConfig.mapMaxZoom);

  // initialize map bounds to include entire seating chart
  map.fitBounds(leafletConfig.mapBounds);

  /**********************************************
   * TILE LAYER
   */
  L.tileLayer(templateUrl + mapTilePath + '{z}/{x}/{y}.png', {
    minZoom: leafletConfig.mapMinZoom,
    maxZoom: leafletConfig.mapMaxZoom,
    tileSize: leafletConfig.tileSize,
    bounds: leafletConfig.mapBounds,
    attribution: 'Rendered with <a href="http://www.maptiler.com/">MapTiler</a>',
    noWrap: true,
    tms: false
  }).addTo(map);

  // Adds a marker for each seat object returned from the CRM for this course/user/category combination
  addSeatMarkers(renderRoom, objChartData, map);

  //Helper event for finding lat/lng when clicking the map
  // map.on('click', function(e) {
  //     console.log(e.latlng);
  // });

  // apply zoom-specific marker styles if necessary
  if (leafletConfig.enableZoomStyles) {
    // Add zoom class for styling hook zoom-
    $('body').addClass('zoom-' + map.getZoom() + ' venue_' + mapVenueName);
  }

  //Hide seat markers while zooming to avoid flickering
  map.on('zoomstart', function() {
    // TODO wait wat?
  });

  // keep zoom-specific marker styles updated as the user zooms
  if (leafletConfig.enableZoomStyles) {
    map.on('zoomend', function(e) {
      var newZoom = e.target._zoom;
      $('body')
        .removeClass('hide-markers zoom-0 zoom-1 zoom-2 zoom-3 zoom-4 zoom-5 zoom-6')
        .addClass('zoom-' + newZoom);
    });
  }
};



(function($){
  // jQuery micro-extension for getting course instance data from a button
  // in the DOM
  $.fn.getEnrollmentData = function() {
    return {
      customerId: this.data('customerid'),
      courseId: this.data('courseid'),
      courseProductId: this.data('courseproductid'),
      categoryId: this.data('categoryid'),
      cartItemKey: this.data('cartitemkey'),
      addCourseToCart: this.hasClass('add-course-to-cart') ? 1 : 0,
      unassignedSeatingRoomName: this.data('roomnameoverride'),
      portionOfClass: this.data('portionofclass'),
      casePresentation: this.data('casepresentation') ? this.data('casepresentation') : '',
      templateId: this.data('templateid'),
      jwt: this.data('jwt'),
    };
  };

  function initSeatingPopups(event, strContainSelector){
    // http://dimsemenov.com/plugins/magnific-popup/documentation.html
    // Use the provided container selector if provided, otherwise assume this is specified as the initial page load
    var strPopupSelectorPrefix = strContainSelector ?
      strContainSelector+' ' :
      '';
    var strPopupSelector = strPopupSelectorPrefix + '.seating-popup';

    // get the element to click on to trigger popup
    var $popupTrigger = $(strPopupSelector);

    // console.log('Popup Trigger', $popupTrigger);

    // configure Magnific to render a leaflet map when AJAX seating chart
    // comes back with data
    $popupTrigger.magnificPopup({
      type: 'ajax',
      ajax: {
        settings: {
          method: "POST",
          url: urls.ajax
        }
      },
      mainClass: 'mfp-with-zoom',
      showCloseBtn: false,
      zoom: {
        enabled: true,
        duration: 300,
        easing: 'ease-in-out',
      },
      callbacks: {
        elementParse: function(item) {
          var mp = $.magnificPopup.instance;
          var portionOfClass = item.el.data('portionofclass') ||
            (mp.registerBtn && mp.registerBtn.data('portionofclass')) ||
            $('input[name="option"]:checked').val() ||
            '';

          var postData = {
            action: 'render_seating_chart',
            customerId: item.el.data('customerid'),
            courseId: item.el.data('courseid'),
            categoryId: item.el.data('categoryid'),
            cartItemKey: item.el.data('cartitemkey'),
            portionOfClass: portionOfClass,
            templateId: item.el.data('templateid'),
            jwt: item.el.data('jwt'),
          };

          // console.log('callback: OLD elementParse');
          // console.log(postData);

          mp.addCourseToCart = (item.el.hasClass('add-course-to-cart') ? 1 : 0);
          mp.courseProductId = item.el.data('courseproductid');
          //if this is being called from a register button that has a ci popup class call that
          if(item.el.hasClass('invoke-ci-popup')){
            // render the CI agreement popup
            postData.action = 'render_ci_popup_option';
            // flag to check which pop up ajax call we are in for later use
            mp.ciPopup = true;
          } else {
            mp.ciPopup = false;
          }
          if(item.el.hasClass('invoke-portion-of-class-popup')){
            postData.action = 'render_partial_attendance_option';
            postData.courseproductId = item.el.data('courseproductid');
            // flag to check which pop up ajax call we are in for later use
            mp.portionPopup = true;
          } else {
            mp.portionPopup = false;
          }
          mp.st.ajax.settings.data = postData;
          // save the register btn, which still has all the data
          if(!item.el.hasClass('partial-attendance-save-default') && !item.el.hasClass('ci-popup-save-default')){
            mp.registerBtn = item.el;
          }
		  
          // Initialize Leaflet config object
          // get map bounds from DOM, if specified
          var mapBoundsData = item.el.data('mapBounds'),
          mapBounds = false;

          if (mapBoundsData) {
            // parse raw data into an array
            mapBounds = mapBoundsData
              .split(',')
              .map(function(degree) {
                return parseFloat(degree) || 0;
              });

              // expect lat/lng to return a flat, 4-index array
              // lat1,lng1,lat2,lng2 -> 4
              if (mapBounds.length === 4) {
                // configure as a Leaflet-friendly bounds array
                mapBounds = [
                  [mapBounds[0], mapBounds[1]],
                  [mapBounds[2], mapBounds[3]]
                ];
              }
          }

          // get leaflet map config values from DOM, if available
          mp.initLeafletConfig = {
            mapMinZoom: item.el.data('mapMinZoom') || 0,
            mapMaxZoom: item.el.data('mapMaxZoom') || 4,
            mapBounds: mapBounds,
            tileSize: item.el.data('mapTileSize') || 512,
            // enable unless explicitly *disabled* in the DOM
            enableZoomStyles: item.el.data('enableZoomStyles') !== 0,
            enableScaling: item.el.data('enableScaling') === 1,
          };
          mp.refreshOnSave = item.el.data('refreshOnSave') !== 0;
        },
        parseAjax: function(mfpResponse) {
          var objResponseData = $.parseJSON(mfpResponse.data);
          // Save the rendered seating chart markup to mfpResponse.data so the popup will render it properly
          mfpResponse.data = objResponseData.markup;
          // Save the chart data for later use
          this.chartData = objResponseData.chartData;
          this.customerId = objResponseData.customerId;
          this.categoryId = objResponseData.categoryId;
          this.courseId = objResponseData.courseId;
        },
        ajaxContentAdded: function() {
          // init mp instance for reading data from button
          var mp = $.magnificPopup.instance;

          // console.log('mp portionpopup:', mp.portionPopup);

          // init map with defalt room, leaflet config detected from DOM
          if(!mp.portionPopup && !mp.ciPopup){
            $('.mfp-content').removeClass('mfp-content--width-sm');
            mapInit(this.chartData, false, this.initLeafletConfig);
            initRadioButtons($(mp.registerBtn));
          // } else if(mp.portionPopup) {
          //   // re init seating popups to include save button in 
          //   initSeatingPopups();
          //   initRadioButtons($(mp.registerBtn));
          //   $('.mfp-content').addClass('mfp-content--width-sm');
          }else{
            initSeatingPopups();
            initRadioButtons($(mp.registerBtn));
            $('.mfp-content').addClass('mfp-content--width-sm');
          }

          initRoomToggles();
          initCancelButton();
          initPreviewSeatButton();

          $('.seating-chart-save').click(__registerBtnClickEventHandler(false, this.refreshOnSave));
        }
      }
    });

    // skip seating chart and proceed to cart
    $('.skip-seating-chart').click(__registerBtnClickEventHandler(true, true, $('.skip-seating-chart').hasClass('partial-attendance-save-default'),$('.skip-seating-chart').hasClass('ci-popup-save-default')));
  }

  /**
   * Get a callback function to handle the click event for the register button,
   * whether that button is in the seating chart popup or elsewhere.
   * @return function
   */
  function __registerBtnClickEventHandler(sittingInBoardRoom, refreshOnSave, partialAttendanceSave = false, ciPopupSave = false) {
    var wpAjaxAction = sittingInBoardRoom ?
      'add_course_product_to_cart' :
      'reserve_course_seat';

    // Depending on the context, get the enrollment data from a different place
    // TODO make it so we don't have to do this??
    var enrollmentGetter;
    if (sittingInBoardRoom && !partialAttendanceSave && !ciPopupSave) {
      // `this` refers to the register button itself (no seating chart popup)
      enrollmentGetter = function() {
        return $(this).getEnrollmentData();
      };

    } else {
      // `this` refers to the save button in the popup
      enrollmentGetter = function() {
        return $.magnificPopup.instance.registerBtn.getEnrollmentData();
      };
    }

    // return the event handler
    return function(e) {
      e.preventDefault();

      // Clear out any existing error messages
      $('#seating-chart-message-target').html('');

      // this refers to the event target
      var $registerBtn = $(this);

      // indicate loading state
      $registerBtn.addClass('loading');

      // get the enrollment data to send
      var enrollment = enrollmentGetter.call(this);

      var roomName;
      // Get the name of the room where this user will be sitting
      if(sittingInBoardRoom){
        // Sitting in the board room can also apply to unassigned seating in a non-Kois facility, so check for an override room name
        roomName = enrollment.unassignedSeatingRoomName ? enrollment.unassignedSeatingRoomName : 'Board Room';
      } else{
        roomName = $('input#selected-seat-room-name').val() || false;
      }

      // mix enrollment data with other data from DOM
      var ajaxParams = $.extend(enrollment, {
        action: wpAjaxAction,
        seatRoomName: roomName,
        // get seat data from popup/course template
        seatId: $('input#selected-seat-record-id').val() || '',
        seatNumber: $('input#selected-seat-number').val() || '',
        refreshOnSave: refreshOnSave ? 1 : 0
      });

      var doneLoading = function() {
        $registerBtn.removeClass('loading');
      };

      // make the AJAX call to the appropriate endpoint/action
      beginCourseProductEnrollment(ajaxParams).done(function(response) {
        if(response.success) {
          // Emit a custom event with the reserved seat data, for use elsewhere in the application
          // (e.g. To update displayed seat info on Symposium registration pages)
          $('body').trigger( 'kois.seatReserved', {
            seatId: parseInt( enrollment.seatId ) || '',
            seatExpiration: response.seatExpirationTimestamp || '',
            seatNumber: enrollment.seatNumber || '',
            courseRecordId: enrollment.courseId || '',
            portionOfClass: enrollment.portionOfClass || '',
            cartItemKey: response.cartItemKey || '',
          } );
        }

        if(response.success && refreshOnSave) {
          doResponseRedirect(response);
        }
        else if(response.success){
          doneLoading();
          $.magnificPopup.close();
        }
        else if(response.message){
          $('#seating-chart-message-target').html(response.message);
          // Initialize seating chart popup link in erroe message
          initSeatingPopups();
          doneLoading();
        }
        else{
          // TODO: What do we want to do in this case?
          console.log('An error occurred, but no error message was returned.');
          doneLoading();  // at least we know we shouldn't keep telling the user
                          // it's still loading...
        }
      });
    };
  }

  initSeatingPopups();

  // Init popup for Payment options when event triggered
  $('body').on('initSeatingPopups', initSeatingPopups);
  // Also init seating popups when WC fragments are updated to account for fragments which contain seating popup links
  $('body').on('wc_fragments_refreshed', initSeatingPopups);

  // When WooCommerce checkout encounters an error, make sure we initialize seating popups to account for error messages which contain a seating chart popup link
  $(document.body).bind( 'checkout_error', function() {
    initSeatingPopups();
  });
})(jQuery);

// initialize portion options radio buttons
function initRadioButtons(regButton){
  $('.portions-radio-container input[type=radio][name=option]').change(function() {
    var portionOfClassValue = $(this).val();

    // Save the portion of class to the register button
    regButton
      .attr('data-portionofclass', portionOfClassValue)
      .data('portionofclass', portionOfClassValue);

    if ($('.partial-attendance-save-default').prop('disabled')) {
      $('.partial-attendance-save-default').prop('disabled', false);
    }
  });

  $('.case-presentation-radio-container input[type=radio][name=case-presentation-option]').change(function() {
    var casePresentationValue = $(this).val();
    // Save the portion of class to the register button
    regButton.attr('data-casepresentation', casePresentationValue);
    
    // Check if we should enable the save button
    checkEnableSubmit();
  });
}

// Close the popup and destroy the map
function initCancelButton(){
  $('.popup-cancel-btn').on('click', function(e){
    e.preventDefault();
    $.magnificPopup.close();
    destroyMap(map);
  });
}
// Disable preview seat button if no URL to the preview page
function initPreviewSeatButton() {
  $('#preview-seat-views').on('click', function(e) {
    let href = $(this).attr('href');
    if (!href || href === '#') {
      e.preventDefault();
      return false;
    }
  });
}
// Changing maps after map has been initialized without closing magnific popup
function initRoomToggles(){
  $('.room--toggle').each(function(){
    $(this).on('click', function(e){
      // • Remove any active room states and apply to only the currently clicked room.
      // • Sort of like tabs but not real tabs.
      $('.room--toggle').removeClass('room--active').addClass('room--default');
      $(this).removeClass('room--default').addClass('room--active');

      var customerId = $(this).data('customerid');
      var courseId = $(this).data('courseid');
      var categoryId = $(this).data('categoryid');
      var room = $(this).data('room');

      // If clicking on the overflow toggle, and the main room is currently displayed, re-render the map
      if (room === 'overflow' && curRoom === 'main'){
        reRenderMap(customerId, courseId, categoryId, room);
        // If clicking on the overflow toggle, and the overflow room is currently displayed, do nothing
      } else if (room === 'overflow' && curRoom === 'overflow'){
        e.preventDefault();
        // If clicking on the main toggle, and the overflow room is currently displayed, re-render the map
      } else if (room === 'main' && curRoom === 'overflow'){
        reRenderMap(customerId, courseId, categoryId, room);
      } else {
        e.preventDefault();
      }
    });
  });
}

function checkEnableSubmit() {
  const hasCasePresentationOption = $('.case-presentation-radio-container').length > 0;
  const casePresentationSelected = $('input[name="case-presentation-option"]:checked').length > 0;
  const seatSelected = $('input#selected-seat-record-id').val() !== '';
  
  // Only enable if either:
  // 1. There's no case presentation option and a seat is selected
  // 2. Both case presentation is selected and seat is selected
  const shouldEnable = (!hasCasePresentationOption && seatSelected) || 
                      (hasCasePresentationOption && casePresentationSelected && seatSelected);
  
  $('.seating-chart-save').prop('disabled', !shouldEnable);
}

function reRenderMap(customerId, courseId, categoryId, renderRoom) {
  // • Destroy our map so we can re-initialize it with the correct room
  destroyMap(map);

  // • Request new room annnnnd boom.
  $.ajax({
    method: "POST",
    url: urls.ajax,
    data: {
      action: 'render_seating_chart',
      customerId: customerId,
      courseId: courseId,
      categoryId: categoryId,
      renderRoom: renderRoom
    }
  }).done(function(data) {
    var objResponse = $.parseJSON(data);
    var objChartData = objResponse.chartData;
    var strRenderRoom = objResponse.renderRoom;
    curRoom = strRenderRoom;
    mapInit(objChartData, strRenderRoom, {});
  });
}

//renderRoom, objChartData, map
function addSeatMarkers(renderRoom, objChartData, map) {
  var objSeatsData;
  var strRoomName = '';
  var blnSeatingChartLocked = true;
  
  if(renderRoom === 'main' && objChartData && objChartData.classrooms.main.seats){
    objSeatsData = objChartData.classrooms.main.seats;
    strRoomName = objChartData.classrooms.main.name;
  }
  else if(renderRoom === 'overflow' && objChartData && objChartData.classrooms.overflow.seats){
    objSeatsData = objChartData.classrooms.overflow.seats;
    strRoomName = objChartData.classrooms.overflow.name;
  }

  if(objChartData && objChartData.hasOwnProperty('locked')){
    blnSeatingChartLocked = objChartData.locked;
  }

  //Loop through our demo data and add a marker for each seat
  jQuery.each(objSeatsData, function(strSeatRecordId, objSeat) {
    var seatStatusClass = '';
    if(objSeat.UserIsSittingInSeat === true){
      seatStatusClass += 'seat-saved';
    }
    else if(!objSeat.UserCanReserve || blnSeatingChartLocked){
      seatStatusClass += 'seat-occupied';
    }

    var curSeatIcon = seatIcon1;
    curSeatIcon.options.html = buildSeatMarkerHtml(objSeat, seatStatusClass);

    var objCurMarker = L.marker([objSeat.Latitude, objSeat.Longitude], {
      icon: curSeatIcon
    }).addTo(map);

    // Only allow users to click on seats if this seating chart isn't currently locked
    if(!blnSeatingChartLocked){
      objCurMarker.on('click', function(){
        // If the user can't reserve this seat, don't allow the user to select it
        if (!objSeat.UserCanReserve) {
          return false;
        } else {
          //select new seat
          selectedSeat = objSeat.number;

          // selected seat, with or without row number
          var displaySeatNumber = objSeat.SeatNumber;
          if (objSeat.SeatRow) {
            // prepend row
            displaySeatNumber = objSeat.SeatRow+displaySeatNumber;
          }

          $('.seat-icon.seat-selected').removeClass('seat-selected');
          $('.seat-icon.seat-' + objSeat.RecordID).addClass('seat-selected');
          // Update selected room name
          $('input#selected-seat-room-name').val(strRoomName);
          $('#current-room-name-target').html(strRoomName);

          // Update selected seat number to be saved in the cart
          $('input#selected-seat-number').val(displaySeatNumber);

          // This is what gets display to the user under "Seat:"
          $('#current-seat-number-target').html(displaySeatNumber);

          // Update selected seat record id
          $('input#selected-seat-record-id').val(objSeat.RecordID);

          // Update href to preview seat and unhide the button
          let previewSeatHtml = $('#preview-seat-views').html()
            .replace('Preview My Seat', 'Preview Seat View');
          $('#preview-seat-views')
            .html(previewSeatHtml)
            .attr('href', '/admiral-room/seat-' + displaySeatNumber || '')
            .removeClass('btn-hide');
          
          // Check if we should enable the save button
          checkEnableSubmit();
        }
      });
    }

    objCurMarker.on('touchstart',  function(){
      hoveredSeat = objSeat.number;
      $('.seat-icon.seat-' + objSeat.number).addClass('hover');
    }).on('touchend', function() {
      hoveredSeat = null;
      $('.seat-icon').removeClass('hover');
    });
  });
}

function buildSeatMarkerHtml(objSeat, seatStatusClass){
  var tooltipContent = (objSeat.SeatContactData ? objSeat.SeatContactData.join('<br>') : '');
  var markerHtml = '<div class="seat-icon seat-' + objSeat.RecordID + ' ' + seatStatusClass + '">';
      markerHtml += '<span class="seat-marker-number ' + (objSeat.SeatContactData ? 'has-tooltip' : '') + '">';
        markerHtml += objSeat.SeatNumber;
        markerHtml += '<span class="tooltip">' + tooltipContent + '</span>';
      markerHtml += '</span>';
    markerHtml += '</div>';

  return markerHtml;
}

/**
 * Get a Promise to make the enrollment AJAX call
 * @param Object params AJAX params
 * @return Promise
 */
function beginCourseProductEnrollment(params) {
  return $.ajax({
    method: "POST",
    url: urls.ajax,
    data: params
  });
}

/**
 * Do a redirect/refresh according to whether a URL is specified in the response
 * @param Object response the AJAX response
 */
function doResponseRedirect(response) {
  // redirect to the returned URL
  window.location = response.redirect_url || window.location.href;
}

function destroyMap(map) {
  if(map != undefined && map != null && typeof map.remove == 'function'){
    map.remove();
  }
}
